/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartaddpicture4Inputs */

const en_eventaistartaddpicture4 = /** @type {(inputs: Eventaistartaddpicture4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add picture`)
};

const de_eventaistartaddpicture4 = /** @type {(inputs: Eventaistartaddpicture4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add picture" |
*
* @param {Eventaistartaddpicture4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartaddpicture4 = /** @type {((inputs?: Eventaistartaddpicture4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartaddpicture4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartaddpicture4(inputs)
	return de_eventaistartaddpicture4(inputs)
});
export { eventaistartaddpicture4 as "eventAiStartAddPicture" }